jQuery(document).ready(function($) {

  // Remove the doing_wp_cron thing
  setTimeout(function() {
    var hash = $(location).attr("hash");
    history.replaceState && history.replaceState(
      null, '', location.pathname + location.search.replace(/[\?&]doing_wp_cron=[^&]+/, '').replace(/^&/, '?') + hash
    );
  }, 500);

  $('.loading-cover [data-close]').click(function() {
    Cookies.set('ecw_dismiss_location_prompt', true);
    hideLoadingCoverScreen();
  }); 

  // Smooth scroll for anchor links
  $(document).on('click', 'a[href*="#"]:not(.noscroll):not([role="tab"])', function (event) {

    var pagePath = window.location.pathname,
        linkPath = $.attr(this, 'href').substring(0, $.attr(this, 'href').indexOf("#"));
        elementID = $.attr(this, 'href').substring($.attr(this, 'href').indexOf("#"));


    if( (pagePath === linkPath || linkPath.length === 0) && $(elementID).length) {
      event.preventDefault();

      if($(elementID).length) {
        $('html, body').animate({
            scrollTop: $(elementID).offset().top - ($('header.header').outerHeight()  || 0)
        }, 500);
      }
    }
  });

  if($('.gfield_required').length) {
    $('.gfield_required').each(function() {
      $(this).attr('aria-hidden', 'true');
    });
  }

  if($('.ginput_container_phone input').length) {
    $('.ginput_container_phone input').each(function() {
      $(this).before('<span id="'+$(this).attr('id')+'Desc" class="hide">Please enter a 10 digit phone number.</span>');
      $(this).attr('aria-describedby', $(this).attr('id')+'Desc');
    });
  }

  if($('.ginput_container_radio').length) {
    $('.ginput_container_radio').each(function() {
      var rlabel = $(this).prev().text().replace('*', '');
      // console.log(rlabel);
      $(this).find('input[type="radio"]').each(function() {
        $(this).before('<span id="'+$(this).attr('id')+'Desc" class="hide">'+rlabel+': '+$(this).val()+'</span>');
        $(this).attr('aria-describedby', $(this).attr('id')+'Desc');
      });
    });
  }

  $('a:not([data-toggle])').each(function() {
    // var elementText = $(this).text();//.replace((/  |\r\n|\n|\r/gm),"");
    // if(isUrl(elementText)) {
    //   var desc = elementText.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0];
    //   $(this).attr('aria-label', desc);
    // }

    // Catch order links with store ids
    // $(this).on('click', function(e) {
    //   console.log('link click');
    //   e.preventDefault();
    //
    //   var linkHREF = $(this).attr('href');
    //   if(linkHREF.indexOf('?storeid=') != -1) {
    //     var storeID = new RegExp('[\?&]storeid=([^&#]*)').exec(linkHREF);
    //     if(storeID !== null) {
    //       // console.log(storeID[1]);
    //       setAsStore(storeID[1]);
    //       setTimeout(function () {
    //         window.location.href = linkHREF;
    //       }, 500);
    //     } else {
    //       window.location.href = linkHREF;
    //     }
    //   } else {
    //     window.location.href = linkHREF;
    //   }
    // });
  });

  // Accessibility stuff for gutenberg buttons
  $('.wp-block-button__link').each(function() {
    $(this).attr('tabindex', '0');
  });

  // ADA thing with the cookies prompt
  $('#moove_gdpr_strict_cookies').removeAttr('aria-label');

});

function setLoadingCoverScreen(message, clickToClose) {
  var $ = jQuery;

  if(clickToClose) {
    $('.loading-cover [data-close]').removeClass('hide');
  } else {
    $('.loading-cover [data-close]').addClass('hide');
  }

  $('.loading-cover [data-message] strong').text(message);
  $('.loading-cover').removeClass('hidden');
}


function hideLoadingCoverScreen() {
  var $ = jQuery;
  $('.loading-cover [data-message]').text('');
  $('.loading-cover').addClass('hidden');
}

jQuery.fn.scrollTo = function(elem, offset, speed) {
  var $ = jQuery;
  $(this).animate({
    scrollTop:  $(this).scrollTop() - $(this).offset().top + $(elem).offset().top - offset
  }, speed == undefined ? 1000 : speed);
  return this;
};

function isUrl(s) {
   // var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
   var expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
   var regexp = new RegExp(expression);
   return regexp.test(s);
}

function string_to_slug(str) {
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
  var to   = "aaaaeeeeiiiioooouuuunc------";
  for (var i=0, l=from.length ; i<l ; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes

  return str;
}

function debounce( fn, threshold ) {
  var timeout;
  threshold = threshold || 100;
  return function debounced() {
    clearTimeout( timeout );
    var args = arguments;
    var _this = this;
    function delayed() {
      fn.apply( _this, args );
    }
    timeout = setTimeout( delayed, threshold );
  };
}

var decodeEntities = (function() {
  // this prevents any overhead from creating the object each time
  var element = document.createElement('div');

  function decodeHTMLEntities (str) {
    if(str && typeof str === 'string') {
      // strip script/html tags
      str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
      str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
      element.innerHTML = str;
      str = element.textContent;
      element.textContent = '';
    }

    return str;
  }

  return decodeHTMLEntities;
})();

function formatMoney(number, decPlaces="2", decSep=".", thouSep=",") {
    decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
    decSep = typeof decSep === "undefined" ? "." : decSep;
    thouSep = typeof thouSep === "undefined" ? "," : thouSep;
    var sign = number < 0 ? "-" : "";
    var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
    var j = (j = i.length) > 3 ? j % 3 : 0;

    return sign +
        (j ? i.substr(0, j) + thouSep : "") +
        i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
        (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
}

function urlParam(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results==null) {
       return null;
    }
    return decodeURI(results[1]) || 0;
}

Number.prototype.padLeft = function(base,chr){
  var  len = (String(base || 10).length - String(this).length)+1;
  return len > 0? new Array(len).join(chr || '0')+this : this;
}
